import { useCallback, useState } from "react";
import { ORDER, SORTING } from "components/company/CompanyTable/constants";

export interface CompanyTableSortingAction {
  type?: string;
}

export type CompanyTableOnAction = (action?: CompanyTableSortingAction) => void;

export interface CompanyTableSortingHook {
  sorting: string;
  order: string;
  onAction: CompanyTableOnAction;
}

export default function useCompanyTableSorting(): CompanyTableSortingHook {
  const [sorting, setSorting] = useState(SORTING.COMPANY_NAME);
  const [order, setOrder] = useState(ORDER.NORMAL);

  const onAction = useCallback(
    (action: CompanyTableSortingAction = {}) => {
      const { type } = action;

      if (type === "company-alphabetical") {
        if (sorting !== SORTING.COMPANY_NAME) {
          setSorting(SORTING.COMPANY_NAME);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "company-type-alphabetical") {
        if (sorting !== SORTING.COMPANY_TYPE) {
          setSorting(SORTING.COMPANY_TYPE);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "id-alphabetical") {
        if (sorting !== SORTING.ID) {
          setSorting(SORTING.ID);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "companyFlag-alphabetical") {
        if (sorting !== SORTING.FLAG) {
          setSorting(SORTING.FLAG);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "name-alphabetical") {
        if (sorting !== SORTING.CONTACT_NAME) {
          setSorting(SORTING.CONTACT_NAME);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "email-alphabetical") {
        if (sorting !== SORTING.CONTACT_EMAIL) {
          setSorting(SORTING.CONTACT_EMAIL);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === "lifecycle-alphabetical") {
        if (sorting !== SORTING.LIFECYCLE) {
          setSorting(SORTING.LIFECYCLE);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      setSorting(SORTING.COMPANY_NAME);
      setOrder(ORDER.NORMAL);
    },
    [order, sorting]
  );

  return {
    sorting,
    order,
    onAction,
  };
}
